import React from 'react';

function Impressum() {

    return (
        <div className='impressum'>
            <div className='impressum__content'>
                <div className='impressum__text'>
                    <div id='impressum' className='offset'/>
                    <h1>
                        Impressum
                    </h1>
                    <h3>
                        <b>Angaben gemäß § 5 TMG</b><br/>
                        <br/>
                        Sk-Metallbau GmbH<br/>
                        Industriestr. 66<br/>
                        28876 Oyten<br/>
                        Deutschland<br/>
                        <br/>
                        <b>Vertreten durch (Geschäftsführer):</b><br/>
                        Björn Kahrs (Metallbaumeister, Int. Schweißfachmann)<br/>
                        Daniel Sosna<br/>
                        <br/>
                        <b>Kontakt:</b><br/>
                        Telefon: <a href='tel:042079959039'>+49 4207 - 9959039</a><br/>
                        E-Mail: <a href='mailto:info@sk-metallbau.eu'>info@sk-metallbau.eu</a><br/>
                        <br/>
                        Handelsregister: <br/>
                        Amtsgericht Walsrode, HRB 209234<br/>
                        <br/>
                        <b>Umsatzsteuer‑Identifikationsnummer (§ 27 a UStG):</b><br/>
                        *<br/>
                        <br/>
                        <b>Online‑Streitbeilegung:</b><br/>
                        Die Europäische Kommission stellt eine Plattform zur Online‑Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr
                        Unsere E‑Mail-Adresse finden Sie oben.
                        Streitschlichtung: Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                    </h3>
                </div>
                <div className='datenschutz__text'>
                    <div id='datenschutz' className='offset'/>
                    <h1>
                        Datenschutzerklärung
                    </h1>
                    <h3>
                        1. Allgemeine Hinweise<br/>
                        Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften (insbesondere DSGVO) sowie dieser Datenschutzerklärung.<br/>
                        <br/>
                        2. Verantwortliche Stelle<br/>
                        SK Metallbau GmbH<br/>
                        Industriestr. 66<br/>
                        28876 Oyten<br/>
                        Deutschland<br/>
                        E-Mail: info@sk‑metallbau.eu<br/>
                        Telefon: +49 4207 9959039<br/>
                        <br/>
                        3. Erhebung und Verarbeitung personenbezogener Daten<br/>
                        Wir erheben und verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist.<br/>
                        Zu den personenbezogenen Daten zählen insbesondere: Name, Adresse, Telefonnummer, E-Mail-Adresse, IP-Adresse.<br/>
                        <br/>
                        4. Rechtsgrundlagen<br/>
                        Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) oder Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).<br/>
                        <br/>
                        5. Server-Log-Dateien<br/>
                        Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind:<br/>
                        - Browsertyp und Browserversion<br/>
                        - verwendetes Betriebssystem<br/>
                        - Referrer URL<br/>
                        - Hostname des zugreifenden Rechners<br/>
                        - Uhrzeit der Serveranfrage<br/>
                        - IP-Adresse<br/>
                        <br/>
                        6. Cookies<br/>
                        Unsere Internetseiten verwenden Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.<br/>
                        <br/>
                        7. Kontaktformular<br/>
                        Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage gespeichert.<br/>
                        <br/>
                        8. Rechte der betroffenen Person<br/>
                        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft, Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.<br/>
                        <br/>
                        9. Widerruf Ihrer Einwilligung<br/>
                        Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen.<br/>
                        <br/>
                        10. Beschwerderecht bei der zuständigen Aufsichtsbehörde<br/>
                        Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.<br/>
                        <br/>
                        11. Sicherheit der Datenübertragung<br/>
                        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung.<br/>
                        <br/>
                        12. Änderungen dieser Datenschutzerklärung<br/>
                        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie stets den aktuellen rechtlichen Anforderungen anzupassen.<br/>
                    </h3>
                </div>
                <div className='agb__text'>
                    <div id='agb' className='offset'/>
                    <h1>
                        Allgemeinen Geschäftsbedingungen
                    </h1>
                    <h3>
                    Die nachfolgenden Allgemeinen Geschäftsbedingungen gelten für sämtliche Angebote und Verträge
                        und die Lieferungen und Leistungen der Firma SK Metallbau GmbH.
                        <br/>
                        <br/>
                        § 1 Auftragsannahme / Vertragsschluss
                        <br/>
                        Alle Angebote der Firma SK Metallbau GmbH sind bis zur schriftlichen Auftragsannahme durch SK
                        Metallbau GmbH freibleibend. Erst mit der schriftlichen Auftragsannahme durch die SK Metallbau
                        GmbH kommt der Vertrag zustande.
                        <br/>
                        <br/>
                        § 2 Ausführungsfristen
                        <br/>
                        Wird die von der Firma SK Metallbau GmbH geschuldete Leistung durch höhere Gewalt, z.B.
                        Mobilmachung, Krieg, Aufruhr, oder durch ähnliche, nicht von der Firma SK Metallbau GmbH zu
                        vertretene Ereignisse, z.B. Streik oder Aussperrung, verzögert, so verlängert sich die vereinbarte
                        Liefer- und Ausführungsfrist um die Dauer dieser Verzögerung, längstens jedoch um 6 Monate.
                        <br/>
                        <br/>
                        § 3 Gewährleistung / Prüfungspflicht / Lieferung
                        <br/>
                        Die gelieferten Gestände sind gemäß § 377 HGB unverzüglich nach Ablieferung/ Auslieferung an den
                        Besteller / Käufer oder an den von ihm bestimmten Dritten sorgfältig zu untersuchen. Sie gelten
                        hinsichtlich offensichtlicher Mängel oder anderer Mängel, die bei einer unverzüglichen, sorgfältigen
                        Untersuchung erkennbar gewesen wären, als vom Besteller/ Käufer genehmigt, wenn SK Metallbau
                        GmbH nicht binnen 7 Werktagen nach Ablieferung eine schriftliche Mängelrüge zugeht. Hinsichtlich
                        anderer Mängel gelten die Liefergegenstände als vom Besteller / Käufer genehmigt, wenn die
                        Mängelrüge SK Metallbau GmbH nicht binnen 7 Werktagen nach dem Zeitpunkt zugeht, in dem sich
                        der Mangel zeigte; war der Mangel für den Besteller/ Käufer bei normaler Verwendung bereits zu
                        einem früheren Zeitpunkt erkennbar, ist allein dieser frühere Zeitpunkt für den Beginn der Rügefrist
                        maßgeblich. Die Rücksendung erfolgt auf Rechnung des Bestellers / Käufers
                        <br/>
                        Ist der Auftraggeber Kaufmann, ist er verpflichtet, die Lieferung unverzüglich auf Vollständigkeit und
                        Mängel zu prüfen und etwaige Beanstandungen unverzüglich, spätestens aber innerhalb einer
                        Ausschlussfrist von 1 Woche gegenüber der Firma SK Metallbau GmbH schriftlich geltend zu machen.
                        <br/>
                        Bei berechtigten Mängelrügen hat die Firma SK Metallbau GmbH die Wahl, entweder die
                        mangelhaften Gegenstände nachzubessern oder dem Auftraggeber gegen Rücknahme des
                        beanstandeten Gegenstandes Ersatz zu liefern. Solange die Firma SK Metallbau GmbH ihren
                        Verpflichtungen auf Behebung der Mängel nachkommt, hat der Auftraggeber nicht das Recht,
                        Herabsetzung der Vergütung oder Rückgängigmachung des Vertrages zu verlangen, sofern nicht nach
                        dreimaligem Fehlschlagen der Nacherfüllung vorliegt. Satz 1 und Satz 2 gelten nicht bei
                        Verbrauchergeschäften über den Bezug beweglicher Sachen.
                        <br/>
                        Die Firma SK Metallbau GmbH weist darauf hin, dass die von ihr erstellten Konstruktionen und
                        gelieferten Modelle zur Vermeidung von Folgeschäden vor Fertigungsbeginn bzw. vor dem Abguss
                        kontrolliert werden sollten. Aus gleichem Grund sollten die von Firma SK Metallbau GmbH
                        gelieferten Produkte im Probebetrieb getestet werden.
                        <br/>
                        <br/>
                        § 4 Haftung
                        <br/>
                        Die Firma SK Metallbau GmbH haftet in Fällen des Vorsatzes oder der groben Fahrlässigkeit der
                        Firma SK Metallbau GmbH oder ihrer Vertreter oder Erfüllungsgehilfen sowie bei einer schuldhaft
                        verursachten Verletzung des Lebens, des Körpers oder der Gesundheit nach den gesetzlichen
                        Bestimmungen. Im Übrigen haftet die Firma SK Metallbau GmbH nur nach dem
                        Produkthaftungsgesetz, wegen der schuldhaften Verletzung wesentlicher Vertragspflichten oder
                        soweit sie den Mangel arglistig verschwiegen oder eine Garantie für die Beschaffenheit ihrer Leistung
                        übernommen hat. Die Schadensersatzhaftung für die schuldhafte Verletzung wesentlicher
                        Vertragspflichten ist jedoch auf den vertragstypischen vorhersehbaren Schaden begrenzt, soweit
                        nicht zugleich ein anderer der in Satz 1 oder 2 aufgeführten Fälle gegeben ist.
                        <br/>
                        Die Regelungen des vorstehenden Absatzes 1 gelten für alle Schadensersatzansprüche (insbesondere
                        für Schadensersatz neben der Leistung und Schadensersatz statt der Leistung), und zwar gleich aus
                        welchem Rechtsgrund, insbesondere wegen Mängeln, der Verletzung von Pflichten aus dem
                        Schuldverhältnis oder aus unerlaubter Handlung. Sie gelten auch für den Anspruch auf Ersatz
                        vergeblicher Aufwendungen. Die Haftung für Verzug bestimmt sich jedoch nach dem nachstehenden
                        Absatz 4, die Haftung für Unmöglichkeit nach dem nachstehenden Absatz 5 dieses § 4.
                        <br/>
                        Eine Änderung der Beweislast zum Nachteil des Auftraggebers ist mit den vorstehenden Regelungen
                        nicht verbunden.
                        <br/>
                        Die Firma SK Metallbau GmbH haftet bei Verzögerung der Leistung in Fällen des Vorsatzes oder
                        groben Fahrlässigkeit der Firma SK Metallbau GmbH oder eines Vertreters oder Erfüllungsgehilfen
                        sowie bei einer schuldhaft verursachten Verletzung des Lebens, des Körpers oder der Gesundheit
                        nach den gesetzlichen Bestimmungen. In anderen Fällen des Verzugs wird die Haftung der Firma SK
                        Metallbau GmbH für den Schadensersatz neben der Leistung auf insgesamt 10 % und für den
                        Schadensersatz statt der Leistung (einschließlich des Ersatzes vergeblicher Aufwendungen) auf
                        insgesamt 30 % des Wertes der Leistung begrenzt. Weitergehende Ansprüche des Auftraggebers sind
                        – auch nach Ablauf einer der Firma SK Metallbau GmbH etwa gesetzten Frist zur Leistung –
                        ausgeschlossen. Die Beschränkung gilt nicht bei schuldhafter Verletzung wesentlicher
                        Vertragspflichten. Der Schadenersatzanspruch für die schuldhafte Verletzung wesentlicher
                        Vertragspflichten ist jedoch auf den vertragstypischen vorhersehbaren Schaden begrenzt, soweit
                        nicht zugleich auch ein Fall nach Satz 1 dieses Absatzes 4 gegeben ist. Ein nach gesetzlichen
                        Bestimmungen bestehendes Recht des Auftraggebers zum Rücktritt vom Vertrag bleibt hierdurch
                        unberührt. Eine Änderung der Beweislast zum Nachteil des Auftraggebers ist mit den vorstehenden
                        Regelungen nicht verbunden.
                        <br/>
                        Soweit die von der Firma SK Metallbau GmbH nach dem Vertrag geschuldete Leistung unmöglich ist,
                        haftet sie in Fällen des Vorsatzes oder der groben Fahrlässigkeit der Firma SK Metallbau GmbH oder
                        eines Vertreters oder Erfüllungsgehilfen der Firma SK Metallbau GmbH sowie bei einer schuldhaft
                        verursachten Verletzung des Lebens, des Körpers oder der Gesundheit nach den gesetzlichen
                        Bestimmungen. In anderen Fällen der Unmöglichkeit beschränkt sich der Anspruch des Auftraggebers
                        auf Schadensersatz neben und/oder statt der Leistung einschließlich des Ersatzes vergeblicher
                        Aufwendungen insgesamt auf 30 % des Wertes der Leistung. Weitergehende Ansprüche des
                        Auftraggebers wegen Unmöglichkeit sind – auch nach Ablauf einer der Firma SK Metallbau GmbH
                        etwa gesetzten Frist zur Leistung – ausgeschlossen. Die Beschränkung gilt nicht bei schuldhafter
                        Verletzung wesentlicher Vertragspflichten. Der Schadensersatzanspruch für die schuldhafte
                        Verletzung wesentlicher Vertragspflichten ist jedoch auf den vertragstypischen vorhersehbaren
                        Schaden begrenzt, soweit nicht zugleich auch ein Fall nach Satz 1 dieses Absatzes 5 gegeben ist. Ein
                        nach gesetzlichen Bestimmungen bestehendes Recht des Auftraggebers zum Rücktritt vom Vertrag
                        bleibt hierdurch unberührt. Eine Änderung der Beweislast zum Nachteil des Auftraggebers ist mit den
                        vorstehenden Regelungen nicht verbunden.
                        <br/>
                        <br/>
                        § 5 Pauschalierter Schadenersatz
                        <br/>
                        Kündigt der Auftraggeber vor Beginn der Ausführung den Werkvertrag, ist die Firma SK Metallbau
                        GmbH berechtigt, 10 % der Gesamtauftragssumme als Schadenersatz zu verlangen. Dem
                        Auftraggeber bleibt das Recht vorbehalten, nachzuweisen, dass ein geringerer oder kein Schaden
                        entstanden ist.
                        <br/>
                        <br/>
                        § 6 Abnahme / Fälligkeit der Vergütung
                        <br/>
                        Sofern vertraglich eine förmliche Abnahme vorgesehen ist, tritt die Abnahmewirkung auch dann ein,
                        wenn der Auftraggeber vergeblich und in zumutbarer Weise zur Durchführung der Abnahme
                        aufgefordert wurde. Die Abnahmewirkung tritt 10 Werktage nach Zugang der Aufforderung ein. Nach
                        Abnahme ist die Vergütung nach einfacher Rechnungslegung sofort fällig und ohne Skontoabzug zu
                        zahlen, sofern nichts anderes vereinbart ist.
                        <br/>
                        Ist kein individueller Zahlungsplan vereinbart, kann für Teilleistungen in Höhe des Wertzuwachses
                        eine Abschlagszahlung verlangt werden. Wesentliche Mängel berechtigen nur zum Einbehalt in Höhe
                        des zweifachen voraussichtlichen Mängelbeseitigungsaufwandes.
                        <br/>
                        Wechsel und Schecks werden nur zahlungshalber, nicht an Zahlung statt, angenommen.
                        <br/>
                        <br/>
                        § 7 Zeichnungen und Entwürfe
                        <br/>
                        Zeichnungen und Entwürfe, die von der Firma SK Metallbau GmbH oder in deren Auftrag von Dritten
                        hergestellt wurden, sind geistiges Eigentum der SK Metallbau GmbH und bei Nichtdurchführung
                        eines entsprechenden Vertrages bzw. Nichtannahme eines Angebotes unverzüglich zurückzugeben.
                        Dem Kunden ist es untersagt, die Entwürfe und Zeichnungen in diesem Falle zu benutzen oder an
                        Dritte weiterzugeben und/oder in sonstiger Weise in das Urheberrecht der Firma SK Metallbau
                        GmbH einzugreifen. Bei Zuwiderhandlung ist die Firma SK Metallbau GmbH berechtigt, ihren
                        Aufwand für die Entwürfe und Zeichnungen dem Auftraggeber in Rechnung zu stellen, wobei eigener
                        Aufwand mit dem bei Angebotsabgabe üblichen Stundenverrechnungssatz berechnet wird. Bei
                        Streitigkeiten über Aufwand oder Verrechnungssatz entscheidet ein von der Industrie- und
                        Handelskammer Bremen zu benennender Sachverständiger, der zugleich auch über die Verteilung
                        der Kosten des Sachverständigenverfahrens entscheidet. Die Geltendmachung darüber
                        hinausgehender Schäden und von Lizenzansprüchen bleibt vorbehalten
                        <br/>
                        <br/>
                        § 8 Eigentumsvorbehalt
                        <br/>
                        Gelieferte Gegenstände bleiben bis zur vollen Bezahlung sämtlicher Forderungen aus der
                        Geschäftsbeziehung Eigentum der Firma SK Metallbau GmbH.
                        <br/>
                        Der Auftraggeber ist verpflichtet, Standortwechsel der Eigentumsvorbehaltsgegenstände und
                        Zugriffe Dritter auf die Eigentumsvorbehaltsgegenstände, insbesondere Pfändungen der
                        Eigentumsvorbehaltsgegenstände, der SK Metallbau GmbH unverzüglich schriftlich anzuzeigen und
                        die Pfandgläubiger von dem Eigentumsvorbehalt zu unterrichten. Der Auftraggeber ist nicht
                        berechtigt, die ihm unter Eigentumsvorbehalt gelieferten Gegenstände zu veräußern, zu
                        verschenken, zu verpfänden oder zur Sicherheit zu übereignen.
                        <br/>
                        Erfolgt die Lieferung für einen vom Auftraggeber unterhaltenen Geschäftsbetrieb, so dürfen die
                        Gegenstände im Rahmen einer ordnungsgemäßen Geschäftsführung weiter veräußert werden. In
                        diesem Falle werden die Forderungen des Auftraggebers gegen den Abnehmer aus der Veräußerung
                        bereits jetzt in Höhe des Rechnungswertes des gelieferten Vorbehaltsgegenstandes der SK Metallbau
                        GmbH abgetreten, die diese Abtretung annimmt. Bei Weiterveräußerung der Gegenstände auf Kredit
                        hat sich der Auftraggeber gegenüber seinem Abnehmer das Eigentum vorzubehalten. Die Rechte und
                        Ansprüche aus diesem Eigentumsvorbehalt gegenüber seinem Abnehmer tritt der Auftraggeber
                        hiermit an die SK Metallbau GmbH ab, die diese Abtretung annimmt.
                        <br/>
                        Werden Eigentumsvorbehaltsgegenstände als wesentliche Bestandteile in das Grundstück des
                        Auftraggebers eingebaut, so tritt der Auftraggeber schon jetzt die aus einer Veräußerung des
                        Grundstücks oder von Grundstücksrechten entstehenden Forderungen in Höhe des Rechnungswertes
                        der Eigentumsvorbehaltsgegenstände mit allen Neben-rechten an die SK Metallbau GmbH ab, die
                        diese Abtretung hiermit annimmt.
                        <br/>
                        Werden die Eigentumsvorbehaltsgegenstände vom Auftraggeber bzw. im Auftrag des Auftraggebers
                        als wesentliche Bestandteile in das Grundstück eines Dritten eingebaut, so tritt der Auftraggeber
                        schon jetzt gegen den Dritten oder den, den es angeht, etwa entstehende Forderungen auf
                        Vergütung in Höhe des Rechnungswertes der Eigentums-vorbehaltsgegenstände mit allen
                        Nebenrechten an die SK Metallbau GmbH ab, die diese Abtretung annimmt. Bei Verarbeitung,
                        Verbindung und/oder Vermischung der Vorbehaltsgegenstände mit anderen Gegenständen durch
                        den Auftraggeber steht der SK Metallbau GmbH das Miteigentum an der neuen Sache zu im
                        Verhältnis des Rechnungswertes der Vorbehaltsgegenstände zum Wert der übrigen Gegenstände.
                        <br/>
                        <br/>
                        § 9 Montage vor Ort
                        <br/>
                        Montagen durch Firma SK Metallbau GmbH können nur durchgeführt werden, wenn die baulichen
                        Örtlichkeiten ein ungehindertes Arbeiten zulassen und die notwendigen Anlagen und Anschlüsse wie
                        z.B. Gerüste, Krananlagen, Druckluft- u. Stromzuleitungen für Druckluft- u. Elektrowerkzeuge sowie
                        die Kosten der Nutzung der Anlagen und Anschlüsse vom Auftraggeber ohne Berechnungen
                        gegenüber der Firma SK Metallbau GmbH rechtzeitig gestellt werden. Etwaig vor, nach oder bei
                        Durchführung der Montagen zugesagte Unterstützung durch den Auftraggeber wie z.B.
                        Rangierarbeiten, Umbauten oder erforderliche Installationen sind ebenfalls vom Auftraggeber ohne
                        Berechnung gegenüber der Firma SK Metallbau GmbH rechtzeitig zu stellen. Wartezeiten, die darauf
                        zurückzuführen sind, dass der Auftraggeber die vorstehenden Sätze 1 und 2 nicht beachtet und die
                        Firma SK Metallbau GmbH hierdurch bedingt mit der Montage vor Ort zu dem vereinbarten Termin
                        nicht rechtzeitig beginnen oder diese Montage hierdurch bedingt nicht rechtzeitig beenden kann,
                        werden gesondert berechnet.
                        <br/>
                        Montagerechnungen werden wenn nicht anders vereinbart nach Aufwand und Montagebericht
                        abgerechnet.
                        <br/>
                        <br/>
                        § 10 Gerichtsstand und sonstige Bestimmungen
                        <br/>
                        Sind beide Vertragsparteien Kaufleute, so ist ausschließlicher Gerichtsstand der Geschäftssitz der SK
                        Metallbau GmbH.
                        <br/>
                        Es gelten ausschließlich diese allgemeinen Geschäftsbedingungen. Allgemeine Geschäftsbedingungen
                        des Auftraggebers gelten nur insoweit, als die Firma SK Metallbau GmbH ihnen ausdrücklich
                        schriftlich zugestimmt hat.
                        <br/>
                        Die Vertragsparteien unterwerfen sich dem geltenden Recht der Bundesrepublik Deutschland, und
                        zwar auch dann, wenn der Rechtsstreit im Ausland geführt werden muss. Die Bestimmungen des
                        Wiener Übereinkommens über Verträge über Internationalen Warenkauf vom 11. April 1980 finden
                        keine Anwendung.
                        <br/>
                        Die Firma SK Metallbau GmbH wird nicht an einem Streitbeilegungsverfahren vor einer
                        Verbraucherschlichtungsstelle im Sinne des VSBG teilnehmen und ist hierzu auch nicht verpflichtet.
                        (Hinweis gemäß § 36 Verbraucherstreitbeilegungsgesetz).
                        <br/>
                        Sollten einzelne der vorstehenden Bestimmungen ganz oder teilweise unwirksam sein, gleich aus
                        welchem Grunde, wird die Wirksamkeit des Vertrages und der übrigen Bestimmungen nicht berührt.
                    </h3>
                </div>
            </div>
        </div>
    );
}

export default Impressum;